"use client"

import { filterOption } from "@/lib/external-components"
import { fetchBanners } from "@/services/banner"
import { message, Select } from "antd"
import { useEffect, useState } from "react"

export type SelectBannerProps = {
  value?: string
  onChange?: (val: string | undefined) => void
  placeholder?: string
  allowClear?: boolean
  style?: React.CSSProperties
  allowedBannerIds?: number[]
}

export default function SelectBanner({
  value,
  onChange,
  placeholder,
  allowClear = true,
  style,
  allowedBannerIds,
}: SelectBannerProps) {
  const [options, setOptions] = useState<{ value: string; label: string }[]>([])
  const [loading, setLoading] = useState(false)

  const fetchBannerOptions = async () => {
    try {
      setLoading(true)
      const res = await fetchBanners({ locale: "all", publicationState: "live", pageSize: "100" })
      const items: any[] = res?.data || []

      // Filter banners by allowedBannerIds if provided
      let filteredItems = items
      if (allowedBannerIds && allowedBannerIds.length > 0) {
        filteredItems = items.filter(b => allowedBannerIds.includes(Number(b.id)))
      }

      setOptions(filteredItems.map(b => ({ value: String(b.id), label: b.attributes.name })))
    } catch (e) {
      message.error("Không thể lấy banner")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchBannerOptions()
  }, [])

  return (
    <Select
      showSearch
      loading={loading}
      placeholder={placeholder}
      style={{ minWidth: "14rem", ...(style || {}) }}
      optionFilterProp="children"
      filterOption={filterOption}
      options={options}
      allowClear={allowClear}
      value={value}
      onChange={val => onChange?.(val)}
    />
  )
}
